import { userConstants } from "./constants";

let user = sessionStorage.getItem("sn-gestion-legal");

const initialState = user
  ? { loggedIn: true, user: JSON.parse(user) }
  : { user: {} };

export function authentication(state = initialState, action) {
  switch (action.type) {
  case userConstants.LOGIN_REQUEST:
    return {
      loading: true,
    };
  case userConstants.LOGIN_SUCCESS:
    return {
      loading: false,
      loggedIn: true,
      user: action.user,
    };
  case userConstants.LOGIN_FAILURE:
    return {
      loggedIn: false,
      loading: false,
    };
  case userConstants.LOGIN_CANCELLED:
    return { 
      user: {} 
    };
  case userConstants.LOGOUT:
    return { 
      user: { } 
    };
  default:
    return state;
  }
}

